import styled from '@emotion/styled';

export const Footer = styled.div`
  font-weight: 500;

  .footer-menu {
    color: #004b54;
    background: white;
    padding: 50px 0 20px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      padding: 100px 40px 80px 40px;
    }

    .container {
      display: flex;
      width: 100%;
      max-width: 1360px;
      margin-left: auto;
      margin-right: auto;
    }

    .menu-container {
      flex-direction: column;

      @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
        flex-direction: row;
      }
    }

    .h3 {
      margin-top: 0;
      margin-bottom: 19px;

      @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
        margin-bottom: 28px;
      }
    }

    a,
    .label {
      min-width: 40%;
      margin-right: 10%;
      margin-bottom: 26px;
      display: block;
    }

    .links {
      flex: 1;
    }

    .contents {
      display: flex;
      flex-direction: column;

      @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
        flex-direction: row;
      }

      .left,
      .right {
        flex: 1;
      }

      a {
        cursor: pointer;
      }
    }

    .contact {
      flex: 1;

      .description {
        max-width: 600px;
        line-height: 30px;
        margin-top: 0;
        margin-bottom: 48px;

        @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
          margin-top: 30px;
        }
      }
      .contents {
        @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
          padding-top: 3.5rem;
        }
      }
    }
  }
`;

export const FooterBottom = styled.div`
  background-color: #004b54;
  flex-direction: column;
  padding: 30px 16px 42px;
  align-items: left;
  margin: -16px;

  @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
    padding: 40px 36px 40px;
    flex-direction: row;
    margin: 0;
  }

  .container {
    display: flex;
    width: 100%;
    max-width: 1360px;
    margin-left: auto;
    margin-right: auto;
  }

  .legal-links a {
    margin-right: 25px;
    color: #fff;
    display: block;
    margin-bottom: 16px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      display: inline-block;
      margin-bottom: 0;
    }
  }

  .legal-links button {
    cursor: pointer;
  }

  .copyright {
    color: #fff;
    margin-top: 30px;
    margin-left: auto;

    p {
      color: white;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      margin-top: 0;
    }
  }
`;

export const TrustContainer = styled.div`
  padding: 2rem 0;
  ul {
    margin: 0 -12px;
    display: flex;
    li {
      padding: 0 12px;
      list-style-type: none;
      text-decoration: none;
    }
  }
`;
